module.exports = __webpack_public_path__ + "img/0ac3620.jpg";